function reloadTrustpilotWidget() {
  if (window.Trustpilot) {
    const trustpilotWidget = document.querySelector('.cart-drawer__bot-star-wrap .trustpilot-widget');

    if (trustpilotWidget) {
      window.Trustpilot.loadFromElement(trustpilotWidget);
    }
  }
}

function sectionRedering() {
    fetch("?section_id=cart-drawer")
      .then((res) => res.text())
      .then((data) => {
        var cart__html = $(data);
        var render__html = $(".cart-drawer__wrapper", cart__html);
        $(".cart-drawer__wrapper").replaceWith(render__html);
        // var render__html = $(".cart-drawer__progress-wrap", cart__html);
        // $(".cart-drawer__progress-wrap").replaceWith(render__html);
  
        // var render__html = $(".cart-drawer__text em", cart__html);
        // $(".cart-drawer__text em").replaceWith(render__html);
        // var render__html = $(".cart-drawer__bot-details-right h4", cart__html);
        // $(".cart-drawer__bot-details-right h4").replaceWith(render__html);
  reloadTrustpilotWidget();
        cartSlider();
      });
      fetch("?section_id=header")
      .then((res) => res.text())
      .then((data) => {
        var cart__html = $(data);
        var render__html = $(".header__cart", cart__html);
        $(".header__cart").replaceWith(render__html);
        
      });
  
    //   // header 
    // fetch("?section_id=header")
    //   .then((res) => res.text())
    //   .then((data) => {
    //     var cart__html = $(data);
    //     var render__html = $(".header__right-img span", cart__html);
    //     $(".header__right-img span").replaceWith(render__html);
    //   });
    
  }


$(".product-add-btn").on("click", function (e) {
    e.preventDefault();
    if ($(this).closest(".product__btn").hasClass("disabled")) return;
    formData = $(this).closest(".single__product-add-pro").serialize();
    addToCart(formData)
  })

  $(".range-atc").on("click", function (e) {
    e.preventDefault();
    formData = $(this).closest(".shopify-product-form").serialize();
    addToCart(formData)
  })



// cart slider 

function cartSlider(){
    $('.cart-drawer__slider-items').slick({
        dots: true,
        infinite: true,
        slidesToShow: 1,
        arrows: false,
    });
    
  }
  
  cartSlider()


  function addToCart(formData) {
    console.log(formData);
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: formData,
        success: function (data) {
         
            sectionRedering();
            $("body").addClass("cart-open");
      
          
        },
        error: function (err) {
          console.log(err);
        },
      });
    }




    function increment_p(el) {
        var input = el.previousElementSibling;
        var value = parseInt(input.value);
        value = isNaN(value) ? 0 : value
        value++;
        input.value = value;
      
      }
    
      function decrement_p(el) {
        var input = el.nextElementSibling;
        var value = parseInt(input.value);
        if (value > 1) {
          value = isNaN(value) ? 1 : value;
          value--;
          input.value = value;
        }
      }
    




    // match variant and update variant id and variant image 

function selectedVarint() {
    var slectedId = $(".select__variant").val();
    var url = new URL(window.location.href);
    url.searchParams.set("variant", slectedId);
    window.history.replaceState({}, "", url);
    $('.btn_sticky').attr('data-product', slectedId);
    
  }

  
//   // match variant 
  function matchVariant() {
    var updateValue = "";
    $(".product__flavour-item input[type='radio']:checked").each(function () {
  
      updateValue += (updateValue ? " / " : "") + $(this).val();
    })
  
    var isMatchFound = false;
    $(".select__variant option").each(function () {
      
      var optionValue = $(this).text().trim();
  
      if (updateValue.toLowerCase() == optionValue.toLowerCase()) {
        isMatchFound = true;
        $(this).prop("selected", true);
        var variant_pirce = $(this).attr("data-variant-price");

        console.log(variant_pirce);
        $('.sticky-atc__price span').text(variant_pirce);

        var variant__available = $(this).attr("data-variant-available");
        
      
        if (variant__available == 'false') {
          $(".product__btn").addClass("disabled");
          var oos_text = $('.product-add-btn').attr('data-oos-msg') || "Out of stock";
          $(".product-add-btn > span").text(oos_text);
          $(".product-add-btn").attr('data-text', oos_text).data('text', oos_text);
          $(".sticky-atc__button .btn").addClass("disabled");
          $(".sticky-atc__button .btn span").text(oos_text);
          $(".sticky-atc__button .btn").attr('data-text', oos_text);
        } else {
          $(".product__btn").removeClass("disabled");
          var newAtcText = 'Add to cart - ' + variant_pirce;
          var $outerSpan = $(".product-add-btn > span");
          $outerSpan.html('Add to cart - ' + variant_pirce );
          $(".product-add-btn").attr('data-text', newAtcText).data('text', newAtcText);
          $(".sticky-atc__button .btn").removeClass("disabled");
          $(".sticky-atc__button .btn span").text("Add to cart");
          $(".sticky-atc__button .btn").attr('data-text', "Add to cart");
        }
          $(".product__price").text(variant_pirce);
        }
        return true;
      
    });
    
    
  }
  
  $(".product__flavour-item input[type='radio']").change(function () {
    matchVariant();
    selectedVarint();
    var slideIndex = parseInt($(this).attr('data-slide'), 10);

        if (!isNaN(slideIndex)) {
            $('.product__big-imgs').slick('slickGoTo', slideIndex);
        }
  })
  matchVariant();

  var default_slide = $(".product__flavour-item input[type='radio']:checked").attr('data-slide');
  if(default_slide != undefined){
$('.product__big-imgs').slick('slickGoTo', default_slide);
  }
  console.log('data slide - ' + default_slide);
  



  // increment quantity in cart drawer
function increment(el) {
    var input = el.previousElementSibling;
    var value = parseInt(input.value);
    console.log(value)
    value = isNaN(value) ? 0 : value
    value++;
    input.value = value;
    changeQuantity(input);
  
  }
  // decrement quantity in cart drawer
  function decrement(el) {
    var input = el.nextElementSibling;
    var value = parseInt(input.value);
    if (value > 0) {
      value = isNaN(value) ? 0 : value;
      value--;
      input.value = value;
      changeQuantity(input);
    }
  }
  function changeQuantity(input) {
  
    var quantity = $(input).val();
    var data_line = $(input).attr("data-line");
    var data = {
      "line": data_line,
      "quantity": quantity
    };
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      dataType: "json",
      data: data,
      success: function (data) {
        sectionRedering();
      },
      error: function (err) {
        console.log("Error from quantity update")
      }
    })
  
  
  }
  
  
  function removeItem(event, el) {
    event.preventDefault();
    var data_line = $(el).attr("data-line");
    console.log(data_line)
    var deleteData = {
      "line": data_line,
      "quantity": 0
    };
  
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      dataType: "json",
      data: deleteData,
      success: function (data) {
  
        sectionRedering();
      }
    })
  }
  
  
  
 function addToCart_inCart(event, element) {
  event.preventDefault(); // Stop default action
   var variantId = $(element).attr('data-upsell-product'); // Use element
   const $button = $(element);
   const $span = $button.find('span');
   const newText = "Add";
   setTimeout(() => {
    $span.text(newText);
    $button.attr('data-text', newText);
   }, 300);

  var data = {
       id: variantId,
        quantity: 1 
    };
    $.ajax({
        type: "POST",
        url: "/cart/add.js",
       data: data,
        dataType: "json",
        success: function (response) {
          sectionRedering();
        },
        error: function (err) {
            console.log("Error adding product to cart:", err);
        }
    });
  }

  function addToCart_card(event, element) {
  event.preventDefault();
  if ($(element).hasClass("disabled")) return;
   var variantId = $(element).attr('data-product');
   const $button = $(element);
   const $span = $button.find('span');
   const newText = "Adding to cart";
   setTimeout(() => {
    $span.text(newText);
    $button.attr('data-text', newText);
   }, 300);

  var data = {
       id: variantId,
        quantity: 1 
    };
    $.ajax({
        type: "POST",
        url: "/cart/add.js",
       data: data,
        dataType: "json",
        success: function (response) {
          sectionRedering();
          $('body').addClass('cart-open');
          $span.text('Add to cart');
          $button.attr('data-text', 'Add to cart');
        },
        error: function (err) {
            console.log("Error adding product to cart:", err);
        }
    });
  }








  // $(".btn_shop-products").on("click",function(event){
  //   event.preventDefault(); 
  //    var variantId = $(this).attr('data-product-id'); 
   
  //    var data = {
  //        id: variantId,
  //        quantity: 1 
  //    };
   
    
  //   $.ajax({
  //        type: "POST",
  //        url: "/cart/add.js",
  //        data: data,
  //        dataType: "json",
  //        success: function (response) {
  //         sectionRedering();  
  //         $("body").addClass("cart-open");
  //        },
  //        error: function (err) {
  //            console.log("Error adding product to cart:", err);
  //        }
  //    });
  //  })